
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBacklightButtonsColourOn as ObiLightBacklightButtonsColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-backlight-buttons-colour-on.js';
 
 
 

 
 export const ObiLightBacklightButtonsColourOn = createComponent({
   react: React,
   tagName: 'obi-light-backlight-buttons-colour-on',
   elementClass: ObiLightBacklightButtonsColourOnElement,
   events: {
     
   }
  });
 
 